import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Chip as MuiChip, ChipProps as MuiChipProps, Tooltip } from '@mui/material';

const useStyles = makeStyles<void, 'label'>()((_theme, _params, classes) => ({
    root: {
        background: '#F8F8F8',
        padding: 8,
        border: 0,
        borderRadius: 100,
        [`& .${classes.label}`]: {
            color: '#8E8E8E'
        }
    },
    label: {
        fontSize: 12
    },
    icon: {}
}));

export interface ChipProps extends MuiChipProps {
    tooltip?: React.ReactNode;
}

const Chip: React.FC<ChipProps> = (props) => {
    const { classes, tooltip, ...restProps } = props;
    const { classes: innerClasses, cx } = useStyles();
    return (
        <Tooltip title={tooltip}>
            <MuiChip
                variant="outlined"
                classes={{
                    ...classes,
                    root: cx(innerClasses.root, classes?.root),
                    label: cx(innerClasses.label, classes?.label),
                    icon: cx(innerClasses.icon, classes?.icon)
                }}
                {...restProps}
            />
        </Tooltip>
    );
};

export default Chip;
